import React from 'react';
import styled, { useTheme } from 'styled-components';
import ReactLoading from 'react-loading';

const Loading = () => {
  const theme = useTheme();
  return (
    <Container>
      <ReactLoading
        type="spin"
        color={theme.colors.green}
        height="70px"
        width="70px"
      />
    </Container>
  );
};

export default Loading;

const Container = styled.div`
  height: 200px;
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
